import React from "react";
import Log from "../../components/Login";
import Footer from "../../components/Footer";

export default function Login() {
    return(
        <React.Fragment>
            <Log/>
            <Footer/>
        </React.Fragment>
    )
}